
<template>
    <div>
        <div class="storage-info">
            <div class="chart-div">
            <radial-progress-v3
                        :options="{
                                color :     'var(--theme-color-accent)',
                                step  :      d.storage_percent,
                                background: 'var(--theme-color-primary)',
                                percent:     true
                    }">
            </radial-progress-v3>
            </div>
            <div class="data">
                <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" class="top-img">
                    <g transform="translate(-1754 -341)">
                    <g transform="translate(5539 6543)">
                    <circle class="svg--extra-lighten" cx="33" cy="33" r="33" transform="translate(-3785 -6202)" fill="#afd7ff"/>
                    <g transform="translate(-3768 -6186)">
                    <path class="svg--primary" d="M29,20H3a1,1,0,0,1-.89-1.45l5-10A1,1,0,0,1,8,8H24a1,1,0,0,1,.89.55l5,10A1,1,0,0,1,29,20ZM4.62,18H27.38l-4-8H8.62Z" fill="#0080fc"/>
                    <path class="svg--primary" d="M29,18H3a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V19A1,1,0,0,0,29,18Zm-4,5H24a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z" fill="#0080fc"/>
                    <path class="svg--primary" d="M21,16H11a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z" fill="#0080fc"/>
                    </g>
                    </g>
                    </g>
                </svg>
                <h3 class="title-storage">{{t.label_storage}}</h3>
                <p class="subtitle-storage available">{{t.label_available}}</p>
                <h2 class="qtd-storage available">{{ d.storage_available }} GB</h2>
                <div class="line-data"></div>
                <p style="margin-top: 7px;" class="subtitle-storage used">{{t.label_in_use}}</p>
                <h2 class="qtd-storage used">{{ d.storage_used }} GB</h2>
            </div>
        </div>
         <div class="storage_warning" v-text="t.label_storage_warning_24_hours"></div>
         <div class="view__details">
             <a v-text="user_dash_data.translations.view_more_details" @click="viewStorageDetails()"></a>
            <span v-if="processing" style="font-style: italic;font-weight: 100;padding-left: 10px; color: #9a9a9a;" v-text="t.label_processing"></span>
         </div>
        <div class="line"></div>
        <div class="domains-info" v-if="connections_data != null">
            <img class="top-img" src="/internacional/public/office3/img/dashboard/storage/domains.svg"/>
            <h3 class="title-storage">{{ t.label_my_domains }}</h3>
            <div class="progress">
                <div class="progress-bar" role="progressbar"  :style="'width:'+ connections_data.domains_percent+'%'" :aria-valuenow="connections_data.domains_percent" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="progress-label">
                <div>
                    <h2 class="number-wp">{{t.geral}}</h2>
                </div>
                <div>
                    <span>{{t.label_in_use}}</span><br>
                    <div class="domains-used-info" data-toggle="tooltip" data-placement="left" data-html="true" :title="t.help_domains_used">
                        <h2 class="number">{{ connections_data.domains_used }}</h2>
                        <img :src="'/internacional/public/office5/img/franchise_dashboard/svg/info.svg'" />
                    </div>
                </div>
                <div>
                    <span class="txt-right">{{t.label_qtd_total}}</span><br>
                    <h2 class="number txt-right">{{ connections_data.domains_total }}</h2>
                </div>
            </div>
            <div class="progress-label">
                <div>
                    <h2 class="number-wp">WP Pro & <br> Woocomerce</h2>
                </div>
                <div>
                    <span>{{t.label_in_use}}</span><br>
                    <div class="domains-used-info" data-toggle="tooltip" data-placement="left" data-html="true" :title="t.help_domains_used_wordpress_pro">
                        <h2 class="number">{{ connections_data.wordpress_pro.connected }}</h2>
                        <img :src="'/internacional/public/office5/img/franchise_dashboard/svg/info.svg'" />
                    </div>
                </div>
                <div>
                    <span class="txt-right">{{t.label_qtd_total}}</span><br>
                    <h2 class="number txt-right">{{ connections_data.wordpress_pro.available }}</h2>
                </div>
            </div>
        </div>
        <div v-else>
            <img  class="top-img" src="/internacional/public/office3/img/dashboard/storage/domains.svg"/>
            <h3   class="title-storage">{{ t.label_my_domains }}</h3>
            <div  style="font-style: italic;font-weight: 100;padding-left: 25px; color: #9a9a9a; margin-top: 25px;" v-text="t.label_processing"></div>
        </div>
        <div class="line-bottom"></div>
        <div class="profile__bottom__btn">
        	<button
                @click="buyMore()"
        		class="button3"
        		v-text="t.label_buy_more"
                v-if="!user_dash_data.profile_info.isva">
        	</button>
        </div>

    <!-- Modal Buy More -->
    <div class="modal fade" id="ModalBuyMore" tabindex="-1" role="dialog" aria-labelledby="TituloModalCentralizado" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
           <div class="modal-ctn">
               <div class="buy-storage">
                   <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" class="top-img">
                       <g transform="translate(-1754 -341)">
                       <g transform="translate(5539 6543)">
                       <circle class="svg--extra-lighten" cx="33" cy="33" r="33" transform="translate(-3785 -6202)" fill="#afd7ff"/>
                       <g transform="translate(-3768 -6186)">
                       <path class="svg--primary" d="M29,20H3a1,1,0,0,1-.89-1.45l5-10A1,1,0,0,1,8,8H24a1,1,0,0,1,.89.55l5,10A1,1,0,0,1,29,20ZM4.62,18H27.38l-4-8H8.62Z" fill="#0080fc"/>
                       <path class="svg--primary" d="M29,18H3a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V19A1,1,0,0,0,29,18Zm-4,5H24a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z" fill="#0080fc"/>
                       <path class="svg--primary" d="M21,16H11a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z" fill="#0080fc"/>
                       </g>
                       </g>
                       </g>
                   </svg>
                   <h2 class="qtd-buy">+{{d.sell_storage_qtd}} GB</h2>
                   <p class="subtitle-buy available">{{t.label_extras}}</p>
                    <button class="btn-storage button3"
        		           v-text="t.label_buy_now"
                           v-if="!user_dash_data.profile_info.isva"
                            @click="buyExtraStorage()"></button>
               </div>
               <div class="line-sell"></div>
               <div class="buy-domains">
                   <img class="top-img" src="/internacional/public/office3/img/dashboard/storage/domains.svg"/>
                   <h2 class="qtd-buy">+{{d.sell_domain_qtd  + ' ' + t.dns_connection}} </h2>
                   <p class="subtitle-buy l_progress">{{t.label_extra}}</p>
                   <button class="btn-domain button3"
        		           v-text="t.label_buy_now"
                           v-if="!user_dash_data.profile_info.isva"
                           @click="buyExtraConnections()"></button>
               </div>
           </div>
        </div>
        </div>
    </div>
    </div>
    <buy-extra-connection :translations="t.extra_connection_modal" :handlers="h" :allowed="user_dash_data.profile_info.buy_extra_resources" :is_website_agency="user_dash_data.profile_info.is_website_agency"></buy-extra-connection>
    <buy-extra-storage    :translations="t.extra_storage_modal"    :handlers="h" :allowed="user_dash_data.profile_info.buy_extra_resources" :is_website_agency="user_dash_data.profile_info.is_website_agency"></buy-extra-storage>
    <storage-details      :translations="t.storage_details" :details="storage_details"></storage-details>
</div>
</template>

<script>
import qs from "qs";
import Radial from '../franchise_v3/components/radialProgress.vue';
import BuyExtraConnection from '../domains-storage/buyExtraDomainConnection.vue';
import BuyExtraStorage from '../domains-storage/buyExtraStorage.vue';
import StorageDetails from '../domains-storage/storageDetails.vue';
export default {

    name: "user-storage",
    props: ["user_dash_data", "connections"],
    data(){
    	return {
            t: this.user_dash_data.translations,
            d: this.user_dash_data.storage,
            h: this.user_dash_data.handlers,
            connections_data: null,
            storage_details: null,
            processing: false,
            gettingconnections_data: false
    	}
    },
    created() {
      if (!isEmpty(this.connections)) {
        this.connections_data = this.connections
      } else {
        this.getConnectionsData()
      }
    },
    methods: {
        getConnectionsData() {
          let vm = this
          this.gettingconnections_data = true

          axios
            .get(this.user_dash_data.handlers.get_connections_data)
            .then(response => {
              vm.connections_data = response.data
            })
            .catch(error => {
              console.error('error', error)
            })
            .finally(() => {
              vm.gettingconnections_data = false
            })
        },
        //open #ModalBuyMore modal
        buyMore: function(){
            $('#ModalBuyMore').modal('show')
        },
        buyExtraConnections: function(){
            $('#ModalBuyMore').modal('hide')
            $('#modalBuyExtraDomainConnection').modal('show')
        },
        buyExtraStorage: function(){
            $('#ModalBuyMore').modal('hide')
            $('#modalBuyExtraStorage').modal('show')
        },
        viewStorageDetails: function(){
            if(!this.processing){
                let vm = this
                vm.processing = true

                axios
                    .get(this.h.storage_details)
                    .then(function(resposta) {
                        if (resposta.data.success) {
                            vm.storage_details = resposta.data.details
                            $('#modalStorageDetails').modal('show')
                        } else {
                            alertMsg(
                                "error",
                                resposta.data.message
                            );
                        }
                    })
                    .catch(function(error) {
                        // console.log(error);
                    })
                    .finally(function() {
                        vm.processing = false
                    });
            }
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../../scss/office";

$progress:#48D2A0;


label {
	display:block;
	clear:both;
	font-size: 0.8rem;
}
.profile__bottom{
	border-top: 2px solid #e0e2e459;
	border-bottom: 2px solid #e0e2e459;
	padding: 1.2rem 1.8rem 0.5rem 1.8rem;
	display: grid;
	grid-template-columns: 1fr 120px;
	background: #f1f3f6;
	div{
		label{
			margin-bottom: 1rem;
		}
		p{
			color: var(--theme-color-primary);
			font-weight: bold;
		}
	}
}
.number-wp {
    font-size: 1.1em;
    font-weight: bold;
}
.domains-used-info{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    img{
        height: 0.8em;
    }
}
.profile__bottom__btn{
    margin-top: 15px;
	text-align: center;
	padding: 1rem 1rem;
    display: flex;
    width: 100%;
	button, a{
		text-transform: uppercase;
		font-weight: bold;
        flex: 1;
        border-radius: 10px;
        margin: 0 1rem;
	}
}
.storage-info{
    display: flex;
    padding: 0;
    margin-top: 3px;
    .chart-div{
        margin: auto 10%;
        zoom: 1.11;
        @media only screen and (max-width: 600px) {
            margin: auto;
            margin-top: 5%;
        }
    }

    .data{
        width: 50%;
        padding-bottom: 5px;
        float: right;
        @media only screen and (max-width: 600px) {
           width: 100%;
        }
    }
    @media only screen and (max-width: 600px) {
        display: grid;
    }
}

.top-img{
    display: block;
    margin: 0 auto;
    margin-top: 20px;
}


.title-storage{
    text-align: center;
    margin-top: 7px;
}

.subtitle-storage{
    text-align: center;
    font-size: 11px;
    margin-top: 3px;
}

.qtd-storage{
    text-align: center;
    margin: 0;
    font-weight: 600;
}

.available{
    color: var(--theme-color-primary);
}

.used{
    color: var(--theme-color-accent);
}

.subtitle-buy{
    text-align: center;
    font-size: 13px;
    margin-top: 3px;
}

.l_progress{
    color: $progress;
}

.domains-info{
    margin-top: 10px;
}
.line{
	padding: 0.5rem 1.8rem;
}

.line,
.line-bottom{
	border-bottom: 2px solid #e0e2e459;
    width: 98%;
    margin: 0 auto;
}

.line-data{
    padding: 0.2rem;
    border-bottom: 2px solid #e0e2e459;
    margin-right: 3px;
    width: 65%;
    margin: 0 auto;

    @media only screen and (max-width: 600px) {
        width: 50%;
    }
}

.line-sell{
    padding: 0.2rem;
    border-left: 2px solid #e0e2e459;
    border-bottom: 0;

    @media only screen and (max-width: 600px) {
        margin: 20px 0;
        border-bottom: 2px solid #e0e2e459;
        border-left: 0;

    }
}

.progress{
    height: 5px;
    width: 90%;
    margin: auto;
    margin-top: 25px;
}

.progress-bar{
    background-color: $progress;
}

.progress-label{
    width: 85%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 33% auto auto;
    column-gap: 3%;
    padding: 1em;
    align-items: center;

    .text{
        margin-top: 10px;
        width: auto;
    }

    .txt-left{
        float: left;
    }

    .txt-right{
        float: right;
    }

    .number{
        text-align: center;
        margin: 0;
    }
}

.modal-ctn{
    display: flex;
    padding: 0;
    margin-top: 3px;
    .buy-storage{
        width: 50%;
        padding-bottom: 5px;
        float: left;
        @media only screen and (max-width: 600px) {
           width: 100%;
        }
        .qtd-buy{
           text-align: center;
           color: var(--theme-color-primary);
        }
    }

    .buy-domains{
        width: 50%;
        padding-bottom: 5px;
        float: right;
        @media only screen and (max-width: 600px) {
           width: 100%;
        }

        .qtd-buy{
           text-align: center;
           color: $progress;
        }

    }

    button{
        margin: 0 auto;
        display: flex;
        width: 60%;
        justify-content: center;
        border-radius: 50px;
    }
    .btn-domain{
        margin-top: 50px;
        background-color: darken($progress, 5%);
    }
    .btn-storage{
        margin-top: 50px;
        background-color: var(--theme-color-primary);
    }

    @media only screen and (max-width: 600px) {
        display: grid;
    }

}

.modal{
    top: 10%;
    @media only screen and (max-width: 600px) {
        top: 0;
    }
}
.modal-body {
    padding: 20px 30px 50px 30px;
}

.view__details {
    padding: 0.8rem 0.8rem 0 0.8rem;
    text-align: center;
    a {
        border-bottom: none !important;
    }
    a:after {
        content: ">";
        color: var(--theme-color-accent);
        margin-left: .6rem;
        font-family: monospace;
        font-size: 1.1rem;
    }
}

 .view__details > a{
	border: none;
    border-bottom: 1px solid #e9eaea;
    background: transparent;
    width: 100%;
    padding: 5px 0;
    color: var(--theme-color-primary);
    font-weight: bold;
    margin-bottom: 0.1rem;
}

.storage_warning{
    padding: 0.8rem 0.8rem 0 0.8rem;
    font-style: italic;
    color: #747474;
}

</style>



// WEBPACK FOOTER //
// resources/office/js/components/user/userStorage.vue